import gql from 'graphql-tag'
import { sortBy } from 'lodash'
import client from '@stores/apollo'
import { IBuildingDetails, IFloorDetails } from '@api/types'
import { BuildingDetailsFragment } from '@api/fragments'

interface Payload {
  data: { viewer: { company: { buildings: IBuildingDetails[] } } }
}

export default function buildings(includeOldBuildings?: boolean): Promise<IBuildingDetails[]> {
  return client.gql.query({ query, variables: { includeOldBuildings } }).then(
    ({
      data: {
        viewer: {
          company: { buildings },
        },
      },
    }: Payload) => {
      for (const building of buildings)
        building.floors = sortBy(building.floors, 'floor.story') as IFloorDetails[]

      return buildings
    }
  )
}

const query = gql`
  query buildings($includeOldBuildings: Boolean) {
    viewer {
      company {
        buildings(includeOldBuildings: $includeOldBuildings) {
          ...BuildingDetailsFragment
        }
      }
    }
  }
  ${BuildingDetailsFragment}
`
